import { withFloatingSurface } from "./selectSurface"

// Render modal select menus in document.body with these props so the scrollable
// body and sticky footer cannot clip them. 1060 is Bootstrap's popover layer.
const modalSelectMenuProps = {
  menuPosition: "fixed",
  menuPlacement: "auto",
  styles: withFloatingSurface({ menuPortal: base => ({ ...base, zIndex: 1060 }) }),
}

export default modalSelectMenuProps
